/*global wp_ajax_object, pwsL10n,jsPDF, html2canvas */
import { Alert, Button, Carousel, Collapse, Dropdown, Modal } from 'bootstrap'; //quiet
//, Offcanvas, Popover, ScrollSpy, Tab, Toast, Tooltip
import gsap from 'gsap' //quiet
import ScrollToPlugin from "gsap/ScrollToPlugin.js" //quiet
import { toCanvas } from 'html-to-image';

import {BProgress} from '@bprogress/core' //quiet
import Chart from 'chart.js/auto'; //quiet
import ChartDataLabels from 'chartjs-plugin-datalabels';//quiet

import n4dPassword from './password'; //quiet

const bootstrap = {
	Alert,
	Button,
	Carousel,
	Collapse,
	Dropdown,
	Modal,
};
/*
Offcanvas,
Popover,
ScrollSpy,
Tab,
Toast,
Tooltip
*/

class n4d {
	constructor() {
		this.body           = document.querySelector('body')
		this.wrapper        = document.querySelector('.wrapper')
		this.footer         = document.querySelector('#main-footer')
		this.navigation     = document.querySelector('#menu-bar')
		this.navToggle      = document.querySelector('.navbar-toggler')
		this.st             = false
		this.mori           = []
		this.dep            = []

		gsap.registerPlugin(ScrollToPlugin)
	}
	init(){
//Show page
		if (this.wrapper) this.wrapper.classList.add('show');
//Navigation
		if (this.navigation) this.initNav()

		this.forms()
		this.charts()

		const change_url = document.querySelector(".breakdown-filter")
		if (change_url){
			change_url.addEventListener("change", () => {
				window.location.href = change_url.value
			})
		}

		const copys = document.querySelectorAll(".btn-copy")
		if (copys){
			copys.forEach( copy => {
				copy.addEventListener("click", () => {
					const target_id = copy.dataset.target
					if (target_id){
						const target = document.querySelector(target_id)

						if (target){
							navigator.clipboard.writeText(target.value).then(() => {})
						}

					}
				})
			} )
		}

		const filterSyncs = document.querySelectorAll( ".filter-sync" )
		filterSyncs.forEach(el => {
			el.addEventListener("change", () => {
				app.setCookie("posts_per_page", el.value, 60)

				window.location.reload()
			})
		})

		const popup = document.querySelector("#modal-popup")

		const popupModal = new bootstrap.Modal("#modal-popup", {
			keyboard: false
		})

		popup.addEventListener('show.bs.modal', e => {
			const trigger = e.relatedTarget
			const target  = document.querySelector("#delete-me")

			if (target && trigger.dataset.id){
				target.href = "/delete/"+trigger.dataset.id
			}

			target.addEventListener( "click", () => {
				if ( popupModal ) {
					popupModal.hide()
				}
			})
		})

		const popup_profile = document.querySelector("#modal-profile")
		if (popup_profile){
			popup_profile.addEventListener('show.bs.modal', e => {
				const target  = document.querySelector("#delete-user")
				const checkbox = document.querySelector("#account-delete-check")

				if (checkbox){
					checkbox.addEventListener("change",() => {
						target.classList.toggle("disabled", !checkbox.checked)
					})
				}
			})
		}


		const respondents_filters = document.querySelectorAll(".filter-respondents")
		if (respondents_filters){
			respondents_filters.forEach(filter => {
				filter.addEventListener("change", () => {
					const name = filter.name
					const url = new URL(window.location.href)
					  url.searchParams.set(name, filter.value)

					  window.location.href = url.toString()
				})
			})
		}

		if (app.body.classList.contains("pdf-mode")){
			const paper = app.wrapper;
			let pdf_holder = document.querySelector("#pdf-holder");
			let filename = "survey-result";


			if (!pdf_holder) {
				pdf_holder = document.createElement("img");
				pdf_holder.id = "pdf-holder";
				document.body.appendChild(pdf_holder);
			}

			const isMobile = window.matchMedia('(max-width: 767px)').matches;
/*
			if (!isMobile){
				app.exportPaper(paper, pdf_holder, filename)
			}
			else {
				html2canvas( paper, {
					"scale": 1,
					"testRangeBounds": false
				}).then(canvas =>  {
					pdf_holder.src = canvas.toDataURL("image/jpeg", 0.8);

					pdf_holder.onload = () => {

						pdf_holder.style.width = "1000px";

						let file = new jsPDF({
							orientation: 'p',
							unit: 'px',
							format: [1000, pdf_holder.offsetHeight],
							putOnlyUsedFonts: true,
							floatPrecision: 16 // or "smart", default is 16
						});

						file.addImage(pdf_holder, 'JPEG', 0,0, pdf_holder.offsetWidth, pdf_holder.offsetHeight);
						file.save(filename+".pdf");

						const fallback = "/scores/settings";
						let target = fallback;

						if (document.referrer) {
							try {
								// Only accept referrers from your own site
								if (new URL(document.referrer).origin === location.origin) {
									target = document.referrer;
								}
							} catch (e) {}
						}

						location.href = target;
					};
				}).catch(() => {
					console.log("error");
				});
			}
*/

			app.exportPaper(paper, pdf_holder, filename)
		}
	}
	initNav(){
		let lastScrollTop = 0;
		let isChanging    = false;
		let currentSP     = window.pageYOffset || document.documentElement.scrollTop;

		if (currentSP > 0) app.navigation.classList.add("mini")

		window.addEventListener("scroll", function(){
			let st     = window.pageYOffset || document.documentElement.scrollTop;
			if (st > lastScrollTop && st > 100){
				if (!isChanging){
					app.navigation.classList.add("mini");
					app.navigation.classList.remove("active");

					setTimeout(function(){
						isChanging = false;
					}, 200);
					isChanging = true;
				}
			}
			else {
				if (st < lastScrollTop && st > 100) {
					if (!isChanging){
						app.navigation.classList.add("active");
						setTimeout(function(){
							isChanging = false;
						}, 200);
						isChanging = true;
					}
				}
			}
			if (st == 0) app.navigation.classList.remove("mini");
			lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
		}, false);

		const navoc = document.querySelector('#navoc')
		const toggler = document.querySelector('.nav-toggler[data-bs-target="#navoc"]')

		if (navoc && toggler){
			navoc.addEventListener('hide.bs.offcanvas', event => {
				toggler.setAttribute("aria-expanded", false)
			})
			navoc.addEventListener('show.bs.offcanvas', event => {
				toggler.setAttribute("aria-expanded", true)
			})
		}

	}
	forms(){
		this.forms = document.querySelectorAll('.needs-validation')

		const url = new URL(window.location.href);
		const params = new URLSearchParams(url.search);

		// Check if a parameter exists
		if (params.has('validate')) {
			var inv = document.querySelector('form :invalid');
			if (inv){
				const rect = inv.getBoundingClientRect();

				gsap.to(window, { duration: 0.4, scrollTo: rect.top - 200 });
			}

		}


// Loop over them and prevent submission
		Array.from(this.forms).forEach(form => {
			form.addEventListener('submit', e => {
//e.preventDefault()
//e.stopPropagation()

				let errors = form.querySelectorAll("[required]")
				const surveyValidated = form.querySelector("#survey-validated")


				const matches = document.querySelectorAll(".match")
				if (matches){
					matches.forEach( match => {
						const target = match.dataset.linked
						const linked = document.querySelector(target)

						if (linked){
							const feedback = linked.parentElement.querySelector( ".invalid-feedback" )

							if (match.value !== linked.value){
								linked.classList.remove("is-valid")
								linked.classList.add("is-invalid")
								linked.setCustomValidity("mismatch")
//								if (feedback) feedback.innerHTML = "ค่าไม่ตรงกัน"
							}
							else {
								linked.classList.remove("is-invalid")
								linked.classList.add("is-valid")
								linked.setCustomValidity("")
	//							if (feedback) feedback.innerHTML = "โปรดระบุ"
							}
						}
					} )
				}

				if (!form.checkValidity()){
/*
					var list = form.querySelectorAll(':invalid');
					for (var item of list) {
//console.log(item)
					}
*/
					if (form.id == "signupform"){
						e.preventDefault()
						e.stopPropagation()
					}
				}
				else {
					let radios = []

					var list = form.querySelectorAll(':valid');
					for (var item of list) {
						switch(item.type){
							case "radio":
								if (!radios[item.name]) radios[item.name] = false
								if (item.checked){
									radios[item.name] = true
								}
							break
							case "submit":
							break
							default:
								if (!item.value){
									item.classList.add("is-blank")
								}
							break
						}
					}


					for (let vars in radios){
						if (!radios[vars]){
							let inputs = document.querySelectorAll(`input[name="${vars}"]`)
							inputs.forEach(input => {
								input.classList.add("is-blank")
							})
						}
					}
				}


				if (form.id !== "signupform"){
					surveyValidated.value = (form.checkValidity()) ? 1 : 0
					app.form_unlock()
				}

				form.classList.add('was-validated')
			}, false)
		})

		const newPassword = document.getElementById('new-password')
		const submit = document.querySelector("#profile-update")

		if (newPassword) {
			const passwordInput = newPassword.querySelector("#new-password-input")



			if (passwordInput){
				const linked = passwordInput.dataset.linked
				let passwordRetyped = false;
				if (linked){
					passwordRetyped = document.querySelector(linked)
				}


				newPassword.addEventListener('show.bs.collapse', () => {
					passwordInput.setAttribute("type", "text")
					passwordInput.setAttribute("name", "user_password")
					passwordInput.disabled = false
					passwordInput.required = true
					submit.disabled = true

					if (passwordRetyped){
						passwordRetyped.disabled = false
						passwordRetyped.required = true
					}

					passwordInput.dispatchEvent(new Event("change"))
				})
				newPassword.addEventListener('hidden.bs.collapse', () => {
					passwordInput.setAttribute("type", "hidden")
					passwordInput.setAttribute("name", "")
					passwordInput.disabled = true
					passwordInput.required = false
					submit.disabled = false

					if (passwordRetyped){
						passwordRetyped.disabled = true
						passwordRetyped.required = false
					}
				})

				const disallowedList = n4dPassword.userInputDisallowedList()

				passwordInput.addEventListener("change", () => {
					let strength       = n4dPassword.meter( passwordInput.value, disallowedList, passwordInput.value );

					const meter = document.querySelector("#pass-strength-result");



					if (meter) {
						meter.classList.remove( 'short', 'bad', 'good', 'strong' );
						passwordInput.classList.remove( 'short', 'bad', 'good', 'strong' );
					}
					const meter_class = this.passwordMeter(meter, strength)
					passwordInput.classList.add(meter_class)

					submit.disabled = (strength == 2 || strength == 3 || strength == 4) ? false : true

				})
			}
		}

		//PWD REVEAL
		document.querySelectorAll('input[type="password"]').forEach(element => {
			element.classList.add("toggle-password");

			let btn = document.createElement("a")
			btn.classList.add("reveal-password")
			btn.dataset.id = "#"+element.id
			element.parentNode.insertBefore(btn, element.nextSibling)
			element.parentElement.classList.add("password-wrap")

			if (element.classList.contains("strength")){
				element.parentElement.classList.add("input-group")
				const pwdStrength = document.createElement("div")
				pwdStrength.id = "password-strength"
				pwdStrength.classList.add("password-strength")
				pwdStrength.classList.add("input-group-text")
				element.parentNode.insertBefore(pwdStrength, element.nextSibling)
			}

			btn.addEventListener("click", (e) => {
				let field  = document.querySelector(e.target.dataset.id);

				if (field.type == "password"){
					field.type = "text";
					e.target.classList.add("active");

				} else {
					field.type = "password";
					e.target.classList.remove("active");
				}
			});
		});

		this.pwd          = document.querySelector('input.strength')
		if (this.pwd) {
			this.pwd.addEventListener("keyup", this.checkPasswordStrength.bind(this))
			this.pwd.addEventListener("change", this.checkPasswordStrength.bind(this))
			this.pwd.addEventListener("input", this.checkPasswordStrength.bind(this))
			this.retyped = document.querySelector(this.pwd.dataset.linked)
			if (this.retyped) {
				this.retyped.addEventListener("keyup", this.checkPasswordStrength.bind(this))
				this.retyped.addEventListener("change", this.checkPasswordStrength.bind(this))
				this.retyped.addEventListener("input", this.checkPasswordStrength.bind(this))
			}


		}

		const matches = document.querySelectorAll(".match")
		if (matches){
			matches.forEach( match => {
				const target = match.dataset.linked
				const linked = document.querySelector(target)

				if (linked){
					linked.dataset.linked = match.id
					match.addEventListener("change", () => {
						const feedback = linked.parentElement.querySelector( ".invalid-feedback" )

						if (match.value !== linked.value && linked.value !== ""){
							linked.classList.add("is-invalid")
							linked.classList.remove("is-valid")
							linked.setCustomValidity("mismatch")

//							if (feedback) feedback.innerHTML = "ค่าไม่ตรงกัน"

							//
						}
						else if (linked.value !== "") {
							linked.classList.remove("is-invalid")
//							linked.classList.add("is-valid")
							linked.setCustomValidity("")

//							if (feedback) feedback.innerHTML = "โปรดระบุ"
						}
					})
					linked.addEventListener("change", () => {
						match.dispatchEvent(new Event("change"))
					})
				}
			} )
		}

		const confirms     = document.querySelectorAll(".confirm-checkbox input[type='checkbox']")
		const confirm_btns = document.querySelectorAll(".btn-confirm")

		if (confirms && confirm_btns){
			let confirms_total   = confirms.length
			let confirms_checked = 0

			confirms.forEach( el => {
				confirms_checked += (el.checked) ? 1 : 0

				el.addEventListener("change", () => {
					confirms_checked = 0
					confirms.forEach( el => {
						confirms_checked += (el.checked) ? 1 : 0
					})

					if (confirms_total == confirms_checked){
						confirm_btns.forEach(btn => {
							btn.disabled = false
						})
					}
					else {
						confirm_btns.forEach(btn => {
							btn.disabled = true
						})
					}
				} )
			} )

			if ( confirms_total == confirms_checked ){
				confirm_btns.forEach(btn => {
					btn.disabled = false
				})
			}
		}

		const btns_save     = document.querySelectorAll(".btn-save")
		if (btns_save){
			btns_save.forEach( btn => {
				btn.addEventListener( "click", e => {
					e.preventDefault()
					const mode   = document.querySelector("#survey-save-mode")
					const survey = document.querySelector("#surveyform")
					const surveyValidated = document.querySelector("#survey-validated")

					if (mode){
						mode.value = 1

						if (!survey.checkValidity()){
							surveyValidated.value = 0
							var list = survey.querySelectorAll(':invalid');
							for (var item of list) {
//console.log(item)
							}
						}
						else {
							surveyValidated.value = 1
						}

						survey.submit()
					}
				} )
			} )
		}
		const btns_last     = document.querySelectorAll(".btn-last")
		if (btns_last){
			btns_last.forEach( btn => {
				btn.addEventListener( "click", e => {
					e.preventDefault()
					const page   = document.querySelector("#survey-paged")
					const survey = document.querySelector("#surveyform")
					const surveyValidated = document.querySelector("#survey-validated")

					if (!survey.checkValidity()) {
						surveyValidated.value = 0
					}
					else {
						surveyValidated.value = 1
					}
					survey.submit()
				} )
			} )
		}
//hack for safari


		const filter_selects = document.querySelectorAll(".filter-select")
		if (filter_selects){
			const departments = []

			filter_selects.forEach(select => {
				departments.push(select.dataset.target+"-"+select.value)

				select.addEventListener("change", () => {
					const name     = select.dataset.target+"-"+select.value+"-collapse"
					const selected = document.querySelector("input:checked")
					const target     = document.querySelector(name)

					app.dep.forEach( el => el.hide() )

					if (!app.dep[select.value]){
						app.dep[select.value] = new bootstrap.Collapse(name, {
							toggle: false
						})
					}

					app.dep[select.value].show()

					const children = target.querySelectorAll(".form-select")
					if (children){
						children.forEach( (child, index) => {
							if (select.classList.contains('init')) child.value = ""
							if (index > 0) {
								child.disabled = true
							}
							else {
								child.disabled = false
								child.setCustomValidity("Please Select");
							}
						} )
					}

					select.classList.add('init')
				})

				if (select.checked){
					select.dispatchEvent(new Event("change"))
				}
			})
		}
		const select_steps = document.querySelectorAll(".select-steps")
		if (select_steps){
			const department = document.querySelector("#department")

			select_steps.forEach(step => {
				step.addEventListener("change", () => {
					const target_id  = step.dataset.target+"-"+(Number(step.dataset.index) + 1)
					const index      = step.dataset.index
					const target     = document.querySelector(target_id)

					department.value = step.value

					if ( target ){
						if (app.mori[target.id] == undefined){
							app.mori[target.id] = target.innerHTML
						}
						else {
							target.innerHTML = app.mori[target.id]
						}



						target.disabled = false
//						target.value    = ""
						target.setCustomValidity("Please Select");

						let count       = 0
						const options   = target.querySelectorAll("option")
						options.forEach(option => {
							if (option.dataset.parent == step.value){
								option.disabled = false
								option.style.display = "block"
								count++
							}
							else {
								if ( option.value !== "" ){
									option.remove()

//									option.disabled = true
//									option.style.display = "none"
								}
							}
						})
						if (count === 0){
							target.disabled = true
						}
					}
					if (step.value == ""){
						step.setCustomValidity("Please Select")
					}
					else {
						step.setCustomValidity("")
					}
				})
				if (step.value){
					step.dispatchEvent(new Event("change"))
				}
			})
		}

//Enabled Collapse Tree
		document.querySelectorAll('.collapse-trigger').forEach(function(element){
			let name = element.getAttribute("name");
			let target = (element.dataset.target) ? element.dataset.target : "#collapse-"+name;
			let collapseTriggerLinks = document.querySelectorAll('input[name="'+name+'"],select[name="'+name+'"]');

			collapseTriggerLinks.forEach(link => {
				if (target) link.dataset.target = target;
				link.addEventListener("change", function(){
					let subtarget = "";
					const element = document.querySelector(this.dataset.target);

					let target    = bootstrap.Collapse.getOrCreateInstance( element, {"toggle": false});
					let toggle    = ( this.checked && this.classList.contains("collapse-trigger")) ? "show" : "hide";

					if (this.checked && this.classList.contains("trigger-hide")) toggle = "hide";
					if (this.checked && this.classList.contains("trigger-show")) toggle = "show";

					if (link.tagName == "SELECT"){
						let otherValue = link.options[link.options.length - 1].value;

						if (link.dataset.special && link.dataset.special.includes(link.value) ){
							otherValue = link.value;
						}
						toggle = (link.value == otherValue && otherValue !== "") ? "show" : toggle;
					}
					target[toggle]();

					let subtoggle = ( this.checked && this.classList.contains("collapse-trigger-sub") ) ? "show" : "hide";
					if (subtoggle && this.dataset.subtarget !== undefined){
						subtarget = bootstrap.Collapse.getOrCreateInstance( document.querySelector(this.dataset.subtarget), {"toggle": false});

						if ( this.getAttribute("type") == "radio" || ( this.getAttribute("type") == "checkbox"  && this.classList.contains("collapse-trigger-sub") ) ) {
							subtarget[subtoggle]();

							document.querySelectorAll(this.dataset.subtarget + " .is-required").forEach(function(el){
								el.setAttribute("required", "");
								el.required = (subtoggle == "show") ? true : false;
							});
						} else {
							subtarget[subtoggle]();
						}
					}
					else {

						collapseTriggerLinks.forEach(function(el){
							if (el.classList.contains("collapse-trigger-sub") && !el.checked){
								if (el.dataset.subtarget){

									const target_el = document.querySelector(el.dataset.subtarget);
									if (target_el){
										subtarget = bootstrap.Collapse.getOrCreateInstance( target_el, {"toggle": false});
										if (subtarget) subtarget.hide();
										document.querySelectorAll(el.dataset.subtarget + " .is-required").forEach(function(el){
											el.setAttribute("required", "");
											el.required = (subtoggle == "show") ? true : false;
										});
									}
								}
							}
						});

					}



					document.querySelectorAll(this.dataset.target + " .is-required").forEach(function(el){
						el.setAttribute("required", "");
						el.required = (toggle == "show") ? true : false;
					});

				});

				if (link.classList.contains("trigger-show")) link.dispatchEvent(new Event('change'));

				let toggle    = ( element.checked ) ? "show" : "hide";
				if (element.tagName == "SELECT"){
					let otherValue = link.options[link.options.length - 1].value;
					toggle = (element.value == otherValue) ? "show" : toggle;
				}
				document.querySelectorAll(target + " .is-required").forEach(el => {
					el.setAttribute("required", "");
					el.required = (toggle == "show") ? true : false;
				});

			});
			let collapse = document.querySelector(target);
			if ( collapse && !collapse.classList.contains("show") ){
				collapse.querySelectorAll(".form-control,.form-select").forEach(el => {
					if (el.getAttribute("required") !== null){
						el.setAttribute("required", "");
						el.required = false;
						el.classList.add("is-required");
					}
				});
			}
		});
//ENABLE OTHER INLINE
		document.querySelectorAll('.other-inline-trigger').forEach(function(el){
			let name      = el.getAttribute("name")
			let target_id = `#${name}_other`
			const target  = document.querySelector(target_id)
			let otherTriggerLinks = document.querySelectorAll('input[name="'+name+'"],select[name="'+name+'"]');

			if (target){

				otherTriggerLinks.forEach(link => {
					if (target_id) link.dataset.target = target_id;
					link.addEventListener("change", e => {
						let name      = e.target.getAttribute("name")

						document.querySelectorAll(target_id + ".is-required").forEach(input => {
							if (el.checked){
								input.setAttribute("required", "required")
								input.required = true
								input.disabled = false
							}
							else {
								input.setAttribute("required", "")
								input.required = false
								input.value = ""
								input.disabled = true
							}
						});

					});

				})

				if ( el.checked ){
					target.setAttribute("required", "required");
					target.required = true;
					target.disabled = false
				}
				else {
					if (target.getAttribute("required") !== null){
						target.setAttribute("required", "");
						target.required = false;
						target.disabled = false
						target.classList.add("is-required");
					}
					else {
						target.disabled = true
					}
				}
			}
		});
//FORM CHANGE
		const formTriggers = document.querySelectorAll(".form-change")
		if (formTriggers){
			let selected = false
			let ids      = []

			formTriggers.forEach((el, i) => {

				el.addEventListener("change", e => {
					const targets   = (e.target.dataset.hide) ? e.target.dataset.hide.split(",") : false
					const show      = (e.target.dataset.show == 1) ? true : false
					const hideClass = ( el.dataset.hideanimate) ? "blind" : "hide"
					let current     = false;

					if (el.getAttribute("type") == "radio" || el.getAttribute("type") == "checkbox" ){
						const choices = document.querySelectorAll('input[name="'+el.getAttribute("name")+'"]')
						choices.forEach(choice => {
							if (choice.checked) {
								current = choice.value
							}
						})
					}
					else {
						current = e.target.value
					}

					if (targets){
						targets.forEach(target => {
							let item      = (target) ? document.querySelector(target) : false
							if (item == null){
								let name = target.substr(1)

								item = document.querySelector(`input[name=${name}]`)
								if (item) {
									if (item.classList.contains("form-check-input")){
										item = item.parentElement
									}
								}
							}
							const row           = (item) ? item.closest(".row") : false
							const animate       = ( el.dataset.hideanimate) ? el.dataset.hideanimate : false
							const triggerValue  = (item) ? item.dataset.trigger : false
							const triggerValues = (triggerValue.includes(",")) ? triggerValue.split(",") : []

							if (
								((item && triggerValue && (triggerValue == current || triggerValues.includes( current )) || current === false) && !show || (show && triggerValue != current ))
							){
								if (item){
									if (item.classList.contains("form-check")){
										const children = document.querySelectorAll('input[name="'+target.replace("#", "")+'"], input[name="'+target.replace("#", "")+'[]"]')

										children.forEach(child => {
											child.classList.add("ignore")
											if (child.required || current == false){
												child.required = false
												child.classList.add("is-required")
											}

										})

										if (item.dataset.hide){
											const first_child = document.querySelector(target+" .form-check-input")
											if (first_child){
												first_child.checked = false
												first_child.dispatchEvent( new Event("change") )
											} else {
												const hide_targets = item.dataset.hide.split(",")
											}
										}
									}
									item.classList.add("ignore")

									if (item.required == true){
										item.required = false
										item.classList.add("is-required")
									}
								}

								if (row){
									row.classList.add(hideClass)
									row.classList.remove("d-none")

									if (item){
										let name = target.substr(1)
										let target_items = document.querySelectorAll(`input[name=${name}]`)
										target_items.forEach( ti => {
											ti.required = true
										} )
									}

								}


							}
							else if (item) {
								if (item.classList.contains("form-check")){
									const children = document.querySelectorAll('input[name="'+target.replace("#", "")+'"], input[name="'+target.replace("#", "")+'[]"]')
									children.forEach(child => {
										if (child.getAttribute("type") == "checkbox"){
											child.dispatchEvent( new Event("change") )
										}
									})

								}

								if (row){
									if (!animate) row.classList.remove(hideClass)
									row.classList.add("d-none")
									row.classList.remove("closed")

									item.required = false
									item.classList.add("ignore")
								}

								if (item.classList.contains("form-check")){
									const children = document.querySelectorAll('input[name="'+target.replace("#", "")+'"], input[name="'+target.replace("#", "")+'[]"]')
									children.forEach( child => {
										child.classList.remove("ignore")
										if (child.classList.contains("is-required")){
											child.required = true
										}
									})
								}

							}
						})
					}
//ALTERNATIVE TEXT
					const alternates = (e.target.dataset.alternates) ? e.target.dataset.alternates.split(",") : false
					if (alternates){
						alternates.forEach(target => {

							let item = document.querySelector(target)

							if (!item){
								let radio_item = target.substring(1)
								item = document.querySelector('input[name="'+radio_item+'"]')
							}


							let label = document.querySelector("label[for="+target.substring(1)+"]")
							if (item && item.dataset.altmode == "hint"){
								let hint = item.parentElement.querySelector(".form-text")
								if (hint) label = hint
							}


							if (label){
								const alt     = item.dataset.alternate
								if (!item.dataset.default) item.dataset.default = label.innerHTML
								const has_required = item.dataset.default.split(" <span");
								if (has_required.length == 2){
									item.dataset.default = has_required[0]
								}
//SET DEFAULT PLACEHOLDER
								if ((item.tagName == "SELECT")){
									const first_option = item.querySelector("option")
									if (first_option && first_option.value == ''){
										if (!item.dataset.defaultPlaceholder && item.dataset.placeholder) item.dataset.defaultPlaceholder = first_option.innerHTML
									}
								}
								else {
									if (!item.dataset.defaultPlaceholder && item.dataset.placeholder) item.dataset.defaultPlaceholder = item.getAttribute("placeholder")
								}

								const triggerValue = (item &&item.dataset.alttrigger) ? item.dataset.alttrigger : item.dataset.trigger


								if (item && triggerValue && triggerValue == el.value || el.getAttribute("type") == "text" && el.readOnly && triggerValue == el.dataset.selected ){

//									item.dataset.alternate = item.dataset.default
									label.innerHTML = alt
									if (item.required || item.classList.contains("is-required")) label.innerHTML += " <span class=\"required\">*</span>"
									if (item.dataset.placeholder) item.setAttribute("placeholder", item.dataset.placeholder)
									if (item.dataset.alternateclass) {
										item.parentElement.parentElement.classList.add(item.dataset.alternateclass)
									}

									if ((item.tagName == "SELECT")){
										const first_option = item.querySelector("option")
										if (first_option && first_option.value == '' && item.dataset.placeholder)
										first_option.innerHTML = item.dataset.placeholder
									}

								} else {
//									item.dataset.alternate = alt
									label.innerHTML = item.dataset.default
									if (item.required || item.classList.contains("is-required")) label.innerHTML += " <span class=\"required\">*</span>"
									if (item.dataset.placeholder) item.setAttribute("placeholder", item.dataset.defaultPlaceholder)
									if (item.dataset.alternateclass) {
										item.parentElement.parentElement.classList.remove(item.dataset.alternateclass)
									}

									if ((item.tagName == "SELECT")){
										const first_option = item.querySelector("option")
										if (first_option && first_option.value == '' && item.dataset.defaultPlaceholder)
										first_option.innerHTML = item.dataset.defaultPlaceholder
									}

									if (triggerValue == e.target.dataset.selected){
										label.innerHTML = item.dataset.default
										if (item.required) label.innerHTML += " <span class=\"required\">*</span>"
									}

								}
							}
						})
					}
//FORCE VALUE
					const forces = (e.target.dataset.forces) ? e.target.dataset.forces.split(",") : false
					if (forces){

						forces.forEach(target => {
							let item = document.querySelector(target)

							if (item){
								if (item.dataset.force && e.target.value == item.dataset.trigger){
									item.value = item.dataset.force
								}
							} else {
								target = target.substring(1);
								item = document.querySelectorAll(`input[name="${target}"]`)
								item.forEach(radio => {
									if (radio.dataset.force == e.target.value){
										if ( radio.value == radio.dataset.force ){
											radio.checked = true
										}
										radio.disabled = true
									}
									else {
										radio.disabled = false
									}
								})
							}

						})

					}
				})

				let current = "";

				if (el.getAttribute("type") == "radio" || el.getAttribute("type") == "checkbox" ){

					const choices = document.querySelectorAll('input[name="'+el.getAttribute("name")+'"]')
					choices.forEach(choice => {
						if (choice.checked) {
							current = choice.value
						}
					})
				}
				else {
					current = el.value
				}

				if (current == ""){
					const targets = (el.dataset.hide) ? el.dataset.hide.split(",") : []

					targets.forEach(target => {
						let item = document.querySelector(target)
						if (!item){
							if (item == null){

								let name = target.substr(1);

								item = document.querySelector(`input[name=${name}]`)
								if (item) {
									if (item.classList.contains("form-check-input")){
										item = item.parentElement
									}
								}
							}
						}

						if (item){

							const hideClass = ( el.dataset.hideanimate) ? "blind" : "hide"
							item.closest(".row").classList.add(hideClass)
							item.closest(".row").classList.add("closed")
							item.closest(".row").style.height = 0
							item.classList.add("ignore")

							if (item.required){
								item.required = false
								item.classList.add("is-required")
							}
						}
					})

				}
				else {
					if (el.checked == true){
						selected = el.value
						ids = el.dataset.hide.split(",")
					}
				}
			})
			let toShow = false
			ids.forEach(id => {
				const target   = document.querySelector(id)
				const triggers = target.dataset.trigger.split(",")


				if ( triggers.includes(selected)  ) {
					target.closest(".row").classList.remove("d-none")
				}
				else {
					target.closest(".row").classList.add("d-none")
				}
			})

		}
//CLOSURE
		const surveyClosure = document.querySelector("#survey-closure")
		if (surveyClosure) {
			surveyClosure.addEventListener("change", () => {
				const form = surveyClosure.closest("form")
				form?.submit()
			})
		}


	}
	form_unlock(){
		const fields = document.querySelectorAll("input:required, select:required, textarea:required")
		fields.forEach( field => {
			field.required = false
		} )
	}
	charts(){
		const charts = document.querySelectorAll(".chartjs")
		if (charts){
			const ani = (app.body.classList.contains("pdf-mode")) ? false : true

			charts.forEach( chart => {
				const ctx    = chart.getContext('2d');
				const type   = chart.dataset.type
				let   labels = (chart.dataset.labels) ? chart.dataset.labels.split(",") : []
				const colors = (chart.dataset.colors) ? chart.dataset.colors.split(",") : []
				let   values = (chart.dataset.values) ? chart.dataset.values.split(",") : []
				let   sets   = (chart.dataset.values) ? chart.dataset.values.split(",") : []
				let   p      = (chart.dataset.layout) ? chart.dataset.layout : 100
				let   size   = (chart.dataset.size)   ? chart.dataset.size : 16

				labels = labels.map( v => {
					return v.replace(" ", "\n")
				})
//console.log(labels)
				values = values.map(v => {
					return v * 100
				})

				if (type == "pie"){
					const data = {
						labels: labels,
						datasets: [{
							data: values,
							backgroundColor: colors,
							borderWidth: 0  // Remove borders between slices
						}]
					}

					new Chart(ctx, {
						type: 'pie',
						data: data,
						options: {
							animation: ani,
							layout: {
								padding: {
									top: 0,
									right: p,
									bottom: 0,
									left: p
								}
							  },
							responsive: true,
							plugins: {
								legend: {
									display: false,
									position: 'top',
									labels: {
										color: '#2D2D2D',
										usePointStyle: true,
										pointStyle: 'circle',
										font: {
											family: "Chakra Petch",
											size: 16
										},
										padding: 10,
										borderWidth: 0
									},
									padding: {
										bottom: 60  // Only increase bottom padding
									},
									fullSize: true,
								},
								tooltip: {
									enabled: false  // Disable tooltips
								},
								datalabels: {
									color: '#2D2D2D',
									font: {
									family: "Chakra Petch",  // Set font family to Arial
										size: size
									},
									textAlign: 'center',
									anchor: 'end',
									align: 'end',
									offset: 10,
									formatter: (value, context) => {
										// Show label and value
										if (value === 0) {
										  return null;  // or return ''
										}

										value = Math.round(value)

										return context.chart.data.labels[context.dataIndex] + '\n' + value + '%';
									}
								}
							}
						},
						plugins: [ChartDataLabels]  //,htmlLegendPlugin


					});
				}
				else if (type == "bar"){

					const datasets = []

					sets.forEach( (set, index) => {
						let dataset = set.split("|")

						datasets[index] = {
							label: dataset[0],
							data: dataset[1].split("-"),
							backgroundColor: colors[index],
						}
					})
					const data = {
						labels: labels,
						datasets: datasets
					}


					new Chart(ctx, {
						type: 'bar',
						data: data,
						options: {
							layout: {},
							responsive: true,
							maintainAspectRatio: false,
							scales: {
								x: {
								  grid: {
									display: false  // This removes vertical grid lines
								  },
								  ticks: {
									  font: {
										family: "Chakra Petch"
									  },
									   color: '#2D2D2D',
									}
								},
								y: {
								  ticks: {
									stepSize: 1,
									font: {
									  family: "Chakra Petch"
									},
									 color: '#2D2D2D',
								  }
								}
							  },
							  plugins: {
								  legend: {
									  position: 'top',
									  labels: {
										  color: '#2D2D2D',
										  usePointStyle: true,
										  pointStyle: 'circle',
										  font: {
											  family: "Chakra Petch",
											  size: 12
										  },
										  padding: 10
									  },
									  padding: {
										  bottom: 60  // Only increase bottom padding
									  },
  //									maxWidth: 1000,      // No width restriction
  //									maxHeight: null,     // No height restriction
									  fullSize: true,
  //									display: true
								  },
								  tooltip: {
									  enabled: false  // Disable tooltips
								  },
								  datalabels: {
									  color: '#2D2D2D',
									  font: {
									  family: "Chakra Petch",  // Set font family to Arial
										  size: 16
									  },
									  textAlign: 'center',
									  anchor: 'end',
									  align: 'end',
									  offset: 10,
									  formatter: (value, context) => {
										  // Show label and value
										  return context.chart.data.labels[context.dataIndex] + '\n' + value + '%';
									  }
								  }
							  }
						},
						plugins: {
							legend: {
								position: 'top',
								labels: {
									color: '#2D2D2D',
									usePointStyle: true,
									pointStyle: 'circle',
									font: {
										family: "Chakra Petch",
										size: 16
									},
									padding: 10
								},
							},
							tooltip: {
								enabled: false  // Disable tooltips
							},
						}
					});
				}

			} )
		}

	}
	getCookie(cname){
		let name = cname + "=";
		let decodedCookie = decodeURIComponent(document.cookie);
		let ca = decodedCookie.split(';');
		for(let i = 0; i <ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}
	setCookie(cname, cvalue, exdays){
		const d = new Date();
		d.setTime(d.getTime() + (exdays*24*60*60*1000));
		let expires = "expires="+ d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}
	checkCookie(){
		var popup = app.getCookie("popup-splash");
		if (popup == "") {
			const trigger = document.querySelector("#modal-trigger")
			if (trigger){
				trigger.click()
				app.setCookie("popup-splash", true, 1);
			}
		}
	}
	passwordMeter(meter, strength){
		let value = ""
		switch ( strength ) {
			case 2:
				value = 'bad'
				meter.innerHTML = pwsL10n.bad;//"โปรดตั้งรหัสผ่านตามเกณฑ์ที่กำหนด";
			break;
			case 2:
			case 3:
				value = 'good'
				meter.innerHTML = pwsL10n.good;
			break;

			case 4:
				value = 'strong'
				meter.innerHTML = pwsL10n.strong;
			break;

			case 5:
				value = 'short';
				meter.innerHTML = "รหัสผ่านไม่ตรงกัน";
			break;
			case 6:
				value = 'short';
				meter.innerHTML = "โปรดใช้รหัสผ่านอื่น";
			break;

			default:
				value = 'short';
				meter.innerHTML = "โปรดตั้งรหัสผ่านตามเกณฑ์ที่กำหนด";//pwsL10n.short;
			break;
		}
		meter.classList.add( value )

		return value
	}
	checkPasswordStrength (){
		const input_id     = this.pwd.id
		let form_id        = ""
		const botcheck     = document.querySelector('#bot-check')
		const pwd          = document.querySelector('#pwd')
		let oldpwd         = (pwd) ? pwd.value : false
		let pass1          = this.pwd.value
		let pass2          = (this.retyped !== null) ? this.retyped.value : false
		let disallowedList = n4dPassword.userInputDisallowedList(oldpwd)
		let strength       = n4dPassword.meter( pass1, disallowedList, pass2 )

		this.forms.forEach((form) => {
			let parentForm = form.querySelector("#"+input_id);
			if (parentForm) form_id = form.id;

			if (form_id){
				const submit = document.querySelector("#"+form_id+" input[type=submit]");

				if (submit) submit.disabled = true;
				let meter = document.querySelector("#"+form_id+" #password-strength");
				if (meter) meter.classList.remove( 'short', 'bad', 'good', 'strong' );

				this.passwordMeter(meter, strength)
				if (botcheck) botcheck.value = 1;


				if (strength <= 2){
					this.pwd.setCustomValidity("Invalid field.");
				} else if (strength == 0){
					this.pwd.setCustomValidity("");
					this.retyped.setCustomValidity("");
				}

				if (strength <= 4 && strength > 1 && strength < 5){

					this.pwd.setCustomValidity("");

					if ('' !== pass2.trim() && submit){
						submit.disabled = false;
						if (botcheck) botcheck.value = 1;
					}
				}
				if (strength === 5 || '' === pass2.trim()){
					if (submit) submit.disabled = true;
					this.retyped.setCustomValidity("Invalid field.");
				} else {
					this.retyped.setCustomValidity("");
				}
			}
		});
		return strength;
	}
	/*
	async exportPaper(paper, pdf_holder, filename) {
	  try {
		await document.fonts.ready;

		// 1. Make sure every <img> is actually loaded and decoded
		const imgs = [...paper.querySelectorAll('img')];
		imgs.forEach(img => { img.loading = 'eager'; });
		await Promise.all(imgs.map(img =>
		  img.decode ? img.decode().catch(() => {}) : Promise.resolve()
		));

		// 2. Freeze Chart.js and swap canvases for static images
		const swaps = [];
		paper.querySelectorAll('canvas').forEach(canvas => {
		  const chart = window.Chart?.getChart?.(canvas);
		  if (chart) {
			chart.options.animation = false;
			chart.options.devicePixelRatio = 1;
			chart.resize();
			chart.update('none');
		  }

		  const img = new Image();
		  img.src = canvas.toDataURL('image/png');

		  img.style.cssText = canvas.style.cssText;
		  img.style.width = canvas.clientWidth + 'px';
		  img.style.height = canvas.clientHeight + 'px';
		  img.style.outline = '3px solid red'

		  canvas.style.display = 'none';
		  canvas.parentNode.insertBefore(img, canvas);
		  swaps.push({ canvas, img });
		});


		const options = {
		  pixelRatio: 1,
		  backgroundColor: '#ffffff',
		  cacheBust: true,  // remove unless you really need it; it breaks signed/CDN URLs
//		  skipAutoScale: true,
		  width: 1000,
		  style: { width: '1000px' }   // force desktop layout on mobile
		};

		// 3. Safari warm-up: first call often renders images blank
		await toPng(paper, options).catch(() => {});
		const dataUrl = await toPng(paper, options);

		// 4. Restore the DOM

		swaps.forEach(({ canvas, img }) => {
		  img.remove();
		  canvas.style.display = '';
		});

		// 5. Build the PDF from the data URL directly
		const img = new Image();
		img.src = dataUrl;
		await img.decode();

		const width = 1000;
		const height = Math.round(img.naturalHeight * (width / img.naturalWidth));

		const file = new jsPDF({
		  orientation: 'p',
		  unit: 'px',
		  format: [width, height],
		  compress: true
		});
		file.addImage(dataUrl, 'PNG', 0, 0, width, height, undefined, 'FAST');
		file.save(filename + '.pdf');


		// redirect logic unchanged
		let target = '/scores/settings';
		if (document.referrer) {
		  try {
			if (new URL(document.referrer).origin === location.origin) {
			  target = document.referrer;
			}
		  } catch (e) {}
		}
		location.href = target;

	  } catch (err) {
		console.error('error', err);
	  }
	}
	*/

	async exportPaper(paper, pdf_holder, filename) {
	  const hidden = [];
	  try {
		await document.fonts.ready;

		const charts = [...paper.querySelectorAll('canvas')];

		// Measure the charts before hiding them
		const paperRect = paper.getBoundingClientRect();
		const placements = charts.map(c => {
		  const r = c.getBoundingClientRect();
		  return {
			source: c, // keep the live canvas, no toDataURL needed
			x: r.left - paperRect.left,
			y: r.top - paperRect.top,
			w: r.width,
			h: r.height
		  };
		});

		// visibility:hidden keeps the layout space but doesn't draw the chart
		charts.forEach(c => { hidden.push([c, c.style.visibility]); c.style.visibility = 'hidden'; });

//		const scale = 1000 / paperRect.width;   // output ~1000px wide
		const targetWidth = 2000;          // desired output width in px
		const maxPixels   = 12_000_000;    // safe-ish for iOS; lower to ~8M for older phones

		let scale = targetWidth / paperRect.width;
		const pixels = (paperRect.width * scale) * (paperRect.height * scale);
		if (pixels > maxPixels) {
		  scale = Math.sqrt(maxPixels / (paperRect.width * paperRect.height));
		}

		const options = { pixelRatio: scale, backgroundColor: '#ffffff' };
		await toCanvas(paper, options).catch(() => {});   // Safari warm-up
		const out = await toCanvas(paper, options);

		// Draw the charts straight onto the captured canvas
		const ctx = out.getContext('2d');
		const k = out.width / paperRect.width;
		placements.forEach(p => {
		  ctx.drawImage(p.source, p.x * k, p.y * k, p.w * k, p.h * k);
		});

		// Restore the page
		hidden.forEach(([c, v]) => { c.style.visibility = v; });

		// Build the PDF
		const width = 1000;
		const height = Math.round(out.height * (width / out.width));
		const dataUrl = out.toDataURL('image/png', 1);

		const file = new jsPDF({ orientation: 'p', unit: 'px', format: [width, height], compress: true });
		file.addImage(dataUrl, 'PNG', 0, 0, width, height, undefined, 'SLOW');
		file.save(filename + '.pdf');

		// redirect logic unchanged
		let target = '/scores/settings';
		if (document.referrer) {
		  try {
			if (new URL(document.referrer).origin === location.origin) target = document.referrer;
		  } catch (e) {}
		}
		location.href = target;
	  } catch (err) {
		hidden.forEach(([c, v]) => { c.style.visibility = v; });
		console.error('error', err);
	  }
	}

}
//Create Site APP
let app = new n4d();
//CHECK READY STATE
BProgress.start()

document.onreadystatechange = () => {

	if (document.readyState === 'complete') {
		app.init();
		BProgress.done()
	}
};